import { CSSResultGroup, html, LitElement, nothing } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { style } from './category-filters.style.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'
import { t } from '@cloudsuite/mosaic-shared/translations/translator.js'
import { HiddenFieldsMixin } from 'components/shared/hidden-fields/hidden-fields-mixin.js'
import { TemplateCategory } from 'components/discovery/plp/filters/plp-filters/typing/filters-typing.js'
import { renderAccordionIcons } from 'components/discovery/plp/filters/plp-filters/accordion-icons.js'


export const categoryFiltersHiddenFields = ['count'] as const

@customElement('csc-category-filters')
export class CSCCategoryFilters extends HiddenFieldsMixin(LitElement, categoryFiltersHiddenFields) {
  static override styles: CSSResultGroup = [hostStyle, style]

  @property({ type: Array })
  categories: TemplateCategory[] = []

  @property({ type: String, attribute: 'heading-variant' })
  headingVariant = 'heading-3'

  @property({ type: String, attribute: 'accordion-size' })
  accordionSize = 'md'

  override render() {
    const categories = Array.isArray(this.categories) ? this.categories : []

    return html`
      <cse-accordion
        variant="panel"
        size=${this.accordionSize}
        ?open=${true}
      >
        ${renderAccordionIcons(this.accordionSize)}
        <cse-text slot="title" as="h3" variant="${this.headingVariant}">
          ${t('heading', { ns: 'csc-category-filters', default: 'Categories' })}
        </cse-text>
        <cse-expandable
          slot="content"
          visible-on-init="5"
          variant="list"
        >
          <cse-link slot="toggle-open" class="toggle">
            ${t('show_more', { ns: 'csc-category-filters', default: 'Show more' })}
          </cse-link>
          <cse-link slot="toggle-close" class="toggle">
            ${t('show_less', { ns: 'csc-category-filters', default: 'Show less' })}
          </cse-link>
          <cse-list class="category">
            ${categories.map(category => html`
              <cse-list-item class="category">
                <cse-link variant="secondary" url="${category.url}">
                  ${category.name}
                </cse-link>
                ${!this.isHidden('count') ? html`
                  <cse-badge size="small">${category.count}</cse-badge>
                ` : nothing}
              </cse-list-item>
            `)}
          </cse-list>
        </cse-expandable>
      </cse-accordion>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'csc-category-filters': CSCCategoryFilters,
  }
}
